import {BackendOffDatePlanManager} from 'components/Backend/OffDatePlan/Manager';
export const title = 'VIP休假方案';
export const orderNum = 1;
export default BackendOffDatePlanManager;
